import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

import {
  MutationWithArrayInput,
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";

import {
  HRService,
  setupManagementUrl,
  userManagementUrl,
} from "../../../../config";

import DynamicForm from "../../../../data/Axios/DynamicForm";
import { CompanyCalendarSetupsFormFields } from "../../../../data/DynamicTable/FormsFields/LeaveApplicationForms";
import { allRecurringStatus } from "../../../../data/Queries/HRmanagement/leavemanagement";

const base_url = HRService.uri;

const CalendarSetupForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const [leaveTypes, setLeaveTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const initialValues = {
    recurringTypeId: props.data ? props.data.recurringTypeId : "",
    holiday: props.data ? props.data.holiday : "",
    holidayDate: props.data ? props.data.holidayDate : "",
  
    id: props.data ? props.data.id : '',

  };

  async function fetchLeaveTypes() {
    try {
      const data = await graphqlQuery(allRecurringStatus, setupManagementUrl.uri);
      if (data) {
        setLeaveTypes(data);
      }
    //   const usersdata = await graphqlQuery(allUsers, userManagementUrl.uri);
    //   if (usersdata) {
    //     setUsers(usersdata);
    //   }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    let isMounted = true;
    fetchLeaveTypes();
    return () => {
      isMounted = false;
    };
  }, []);

  const LeaveTypeOptions = leaveTypes
    ? leaveTypes.map((type) => ({
        value: type.id,
        label: type.type,
      }))
    : [];
 
    const fields = [
  ...CompanyCalendarSetupsFormFields,
    {
      name: "recurringTypeId",
      label: "Recurring Type",
      type: "select",
      options: LeaveTypeOptions.map((type) => ({
        value: type.value,
        label: type.label,
      })),
      gridColumn: "span 2",
      required: false,
    },
   
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { recurringTypeId, holiday, holidayDate,  } = values;
     
   
      const mutationData = {
        recurringTypeId,
        holiday,
        holidayDate,
      };
      if (props.isEditing) {
        mutationData.id = props.userData.id;
      }
      const response = await MutationWithArrayInput(
        props.isEditing
          ? "updateCompanyCalendarSetup"
          : "createCompanyCalendarSetup",
        mutationData,
       "setup",
        base_url
      );

      if (response.createLeaveApplication) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Leave application created successfully.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing?"Update Calendar Setup":"Create Calendar Setup"}
      subtitle={props.isEditing?"Update Calendar Setup":"Fill out the form below creating a new calendar setup."}
    />
  );
};

export default CalendarSetupForm;
